import { render, staticRenderFns } from "./InquiryProgressExtended.vue?vue&type=template&id=53907f2c&"
import script from "./InquiryProgressExtended.vue?vue&type=script&lang=js&"
export * from "./InquiryProgressExtended.vue?vue&type=script&lang=js&"
import style0 from "./InquiryProgressExtended.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports